module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/header-text-58f0934d885a54396681118074aaa460.png";